import React, { useEffect, useRef } from 'react';

interface Props {
  onBlobAvailable: (blob) => void;
  prepTime: number;
  recordingTime: number;
}

export default (props: Props) => {
  const audioRecorderRef = useRef(null);

  useEffect(() => {
    if (!audioRecorderRef.current) return;

    new (window as any).AudioRecorder((window as any).$(audioRecorderRef.current));
  }, []);

  return (
    <div className="audio-recorder" data-prep-time={0} data-recording-time={8} ref={audioRecorderRef}>
       <div className="well well-highlight">
        <i className="audio-recorder-instructions" />

        <div className="btn-group">
          <div className="audio-recorder-btn btn btn-large btn-primary">
            <i className="fa" />
            <span>Start Recording</span>
          </div>

          <div className="btn btn-large btn-default disabled audio-recorder-timer" />
        </div>

        <div className="audio-recorder-error alert-message block-message alert alert-warning">
          <p>
            We are working hard to make audio recording available on all devices/browsers. Please use Chrome/Firefox web browsers to continue practicing.
            <br />
            <span>If you continue to have trouble, check out our </span>
            <a href="/speaking-errors-FAQ" target="_blank">FAQs</a>
          </p>
        </div>

        <input
          className="audio-recorder-file-input"
          onChange={(e) => props.onBlobAvailable(e.target.value)}
          style={{ display: 'none' }}
          type="text"
        />
      </div>
    </div>
  );
};
